


















// vendor
import { defineComponent, ref, PropType, set, computed } from "@vue/composition-api";
// local
import { SelectParams } from "../../ts/templates/Select";

type TransformMode = "SelectOne";

const selectOptions:{ value:TransformMode, text:string }[] = [
	{ value: "SelectOne", text: "Select One" }
];

export default defineComponent({

	props:{
		parameters:{
			type:Object as PropType<SelectParams>,
			required:true
		}
	},
	setup(props){

		const mode = computed({
			get:() => props.parameters.mode,
			set:(v) => set(props.parameters, "mode", v)
		});

		return {
			mode,
			options:selectOptions
		};
	}
});

